import { render, staticRenderFns } from "./DeliveriesDetails.vue?vue&type=template&id=5e7ccc3e&scoped=true&"
import script from "./DeliveriesDetails.vue?vue&type=script&lang=js&"
export * from "./DeliveriesDetails.vue?vue&type=script&lang=js&"
import style0 from "./DeliveriesDetails.vue?vue&type=style&index=0&id=5e7ccc3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7ccc3e",
  null
  
)

export default component.exports